// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { DropdownTokens } from './type';

const dropdownTokens: DropdownTokens = {
  dropdownListBorderRadius: 'Radius-default',
  dropdownListBorderColor: 'Neutral-border-1',
  dropdownListBorderWidth: 'Border-1',
  dropdownListPaddingX: 'Spacing-4',
  dropdownListPaddingY: 'Spacing-4',
  dropdownListFontSize: 'Font-14',
  dropdownListFontWeight: 'Weight-regular',
  dropdownListFontColor: 'Neutral-text-5',
  dropdownListSmallBorderRadius: 'Radius-default',
  dropdownListSmallPaddingX: 'Spacing-4',
  dropdownListSmallPaddingY: 'Spacing-4',
  dropdownListSmallFontSize: 'Font-12',
  dropdownListLargeBorderRadius: 'Radius-default',
  dropdownListLargePaddingX: 'Spacing-4',
  dropdownListLargePaddingY: 'Spacing-4',
  dropdownListLargeFontSize: 'Font-16',
  dropdownListBackgroundColor: 'Neutral-fill-1',
  dropdownListBoxShadow: 'Shadow-2',
  dropdownOptionPaddingX: 'Spacing-8',
  dropdownOptionPaddingY: 'Spacing-5',
  dropdownOptionSmallPaddingX: 'Spacing-8',
  dropdownOptionSmallPaddingY: 'Spacing-2',
  dropdownOptionLargePaddingX: 'Spacing-12',
  dropdownOptionLargePaddingY: 'Spacing-8',
  dropdownOptionBackgroundColor: 'Neutral-fill-1',
  dropdownOptionFontColor: 'Neutral-text-5',
  dropdownOptionFontWeight: 'Weight-regular',
  dropdownOptionHoverBackgroundColor: 'Neutral-fill-2',
  dropdownOptionHoverFontColor: 'Neutral-text-5',
  dropdownOptionActiveBackgroundColor: 'Neutral-fill-3',
  dropdownOptionActiveFontColor: 'Neutral-text-5',
  dropdownOptionSelectBackgroundColor: 'Brand-1',
  dropdownOptionSelectFontColor: 'Brand-6',
  dropdownOptionDisabledBackgroundColor: 'Neutral-fill-1',
  dropdownOptionDisabledFontColor: 'Neutral-text-2',
  dropdownOptionBorderRadius: 'Radius-lesser',
  dropdownOptionGroupPaddingX: 'Spacing-8',
  dropdownOptionGroupPaddingTop: 'Font-14',
  dropdownOptionGroupPaddingBottom: 'Spacing-2',
  dropdownOptionGroupFontSize: 'Font-12',
  dropdownOptionGroupFontColor: 'Neutral-text-3',
  dropdownOptionGroupFontWeight: 'Weight-regular',
  dropdownOptionGroupSmallX: 'Spacing-8',
  dropdownOptionGroupSmallTop: 'Spacing-4',
  dropdownOptionGroupLargeX: 'Spacing-12',
  dropdownOptionGroupLargeTop: 'Font-16',
  dropdownOptionGroupLargeBottom: 'Spacing-4',
  dropdownOptionGroupLargeFontSize: 'Font-14',
  dropdownOptionDividerBackgroundColor: 'Neutral-border-1',
  dropdownOptionDividerPaddingX: 'Spacing-8',
  dropdownOptionDividerPaddingY: 'Spacing-2',
  dropdownOptionDividerHeight: 'Border-1',
  dropdownColumnPaddingX: 'Spacing-4',
  dropdownColumnPaddingY: 'Spacing-4',
  dropdownCaretMarginLeft: 'Spacing-4',
};

export default dropdownTokens;
